export const MAP_INIT_POSITION = {
  // (center of the US)
  lat: 39.8283,
  lng: -98.5795,
  zoom: 4,
};

/**
 * The zoom level at which the map should switch from showing pins to showing full polygons.
 */
export const ZOOM_THRESHOLD = 10;

export const MAIN_SOURCE_ID = 'pe-main-source';
export const POINT_SOURCE_ID = 'pe-point-source';
